$(function () {
	const $idLikeTo = $('#searchModal'),
		$idLikeToBtn = $idLikeTo.find('.searchToggleBtn'),
		$idLikeToCloseBtn = $idLikeTo.find('.searchCloseBtn');

	$idLikeToBtn.on('click', function () {
		modalControl($(this));
	});

	$idLikeToCloseBtn.on('click', function () {
		modalControl($(this));
	});

	function modalControl(el) {
		let isExpanded = $idLikeToBtn.attr('aria-expanded') === 'true' ? true : false;

		$idLikeToBtn.attr('aria-expanded', isExpanded ? 'false' : 'true');
		$idLikeToCloseBtn.attr('aria-expanded', isExpanded ? 'false' : 'true');

		if (isExpanded) {
			remove_trap_focus($idLikeTo, 'idLikeToTrap');
			$('.searchContainer').fadeOut(300);
			$('.searchModal-backdrop').fadeOut(300);
		} else {
			trap_focus($idLikeTo, 'idLikeToTrap');
			$('.searchContainer').fadeIn(300);
			$('.searchModal-backdrop').fadeIn(300);
		}
	}
});
